import React from "react";

import styles from "./Header.module.css";

const Header = ({ activeFilters, filters, isLoading, onFilter }) => (
  <div className={styles.Header}>
    <div className={styles.navigation}>
      {isLoading
      ? <div className={styles.loading}>loading</div>
      : <div className={styles.title}>reflections</div>}
    </div>
    {!!filters && (
      <div className={styles.filters}>
        {Object.keys(filters).map(filter => (
          <select key={filter} onChange={e => onFilter(filter, e.target.value)} value={activeFilters[filter]}>
            <option value={filter} key={filter}>{filter}</option>
            {filters[filter].map(option => <option value={option} key={option}>{option}</option>)}
          </select>
        ))}
      </div>
    )}
  </div>
);

Header.propTypes = {
};

export default Header;
